module.exports = __webpack_public_path__ + "static/media/1POLICY11.eae2260a.jpg";